import { useEffect } from 'react'

const APP_NAME = 'Stagehand'

/**
 * Sets the document title for the current page (React_Web_Standards §11.1:
 * page titles must update on route change). Call once at the top of every
 * page component: `usePageTitle('Home')` → "Home · Stagehand".
 */
export function usePageTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME
  }, [title])
}
